
import Pill from "@/Components/General/Pill.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiShape } from "@mdi/js";
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  components: {
    Pill,
    SvgIcon,
  },
  data() {
    return {
      categoryIcon: mdiShape,
    };
  },
});
